import React, { Component } from 'react';
import './Wish.scss';
import { connect } from 'react-redux';
import FormInfo from '../Component/FormInfo';
import DonationForm from './WishElements/WishDonateForm';
import WishInfo from '../Component/WishInfo';
import BackButton from './HomeElements/BackButton';

const FormSection = props => {
  if (props.wish.fulfilled) {
    return null;
  }

  return (
    <React.Fragment>
      <div className="row">
        <div className="col-md-8 col-md-offset-2 col-sm-12 text-md-center text-lg-center form-info">
          <FormInfo
            listname={props.child.listname}
            purchase={props.wish.purchase}
          />
        </div>
      </div>
      <div className="row">
        <div className="col-md-8 col-md-offset-2">
          <DonationForm wish={props.wish} child={props.child} />
        </div>
      </div>
    </React.Fragment>
  );
};

class Wish extends Component {
  getWishForId() {
    let resWish = null;
    for (let child of this.props.childrenList) {
      for (let wish of child.wishes) {
        if (wish.id === parseInt(this.props.match.params.id, 10)) {
          resWish = wish;
        }
      }
    }
    return resWish;
  }

  getChildForId() {
    let resChild = null;
    for (let child of this.props.childrenList) {
      for (let wish of child.wishes) {
        if (wish.id === parseInt(this.props.match.params.id, 10)) {
          resChild = child;
        }
      }
    }
    return resChild;
  }

  renderWish(wish, child) {
    let title = 'Sie spenden für: ';
    return (
      <React.Fragment>
        <div className="col-md-12">
          <div className="row">
            <div className="row col-md-10 col-md-offset-1 header">
              <h1 className="text-md-center text-lg-center">
                {title}
                <br />
                {wish.label}
              </h1>
              <small className="text-md-center text-lg-center">
                <WishInfo
                  amount={wish.amount}
                  amountCollected={wish.amountCollected}
                  purchase={wish.purchase}
                  fulfilled={wish.fulfilled}
                />
              </small>
            </div>
            <div className="row">
              <div className="col-md-8 col-md-offset-2 text-md-center text-lg-center">
                <p>{wish.description}</p>
              </div>
            </div>
            <div className="row">
              <div className="col-md-10 col-md-offset-1">
                <div className="child-info">
                  <img
                    className="media-object img-circle child-img"
                    alt="child avatar"
                    src={child.avatarUrl + '/80'}
                  />
                  <div className="child-name-bar">
                    <h4 className="child-name">
                      Gewünscht von <strong>{child.listname}</strong>
                    </h4>
                    <p className="child-age">{child.age} Jahre alt</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="row col-md-12">
          <FormSection wish={wish} child={child} />
        </div>
      </React.Fragment>
    );
  }

  renderNotFound() {
    return (
      <div className="row">
        <div className="col-md-12">
          <h4>Entschuldigen Sie, der Wunsch kann nicht gefunden werden.</h4>
        </div>
      </div>
    );
  }

  render() {
    let wish = this.getWishForId();
    let child = this.getChildForId();
    return (
      <React.Fragment>
        <BackButton />
        <div className="wishPage">
          {wish && child ? this.renderWish(wish, child) : this.renderNotFound()}
        </div>
      </React.Fragment>
    );
  }
}

const mapStateToProps = state => {
  return {
    childrenList: state.childrenListReducer.list
  };
};

const mapDispatchToProps = dispatch => {
  return {};
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Wish);



// WEBPACK FOOTER //
// ./src/Containers/Wish.js